import styled from "styled-components";

export const CurrencyAmountErrorMessageBox = styled.div<{visible: boolean}>`
    color: ${props => props.theme.colors.danger};
    visibility: ${props => props.visible ? 'visible' : 'hidden'};
    font-size: 0.8em;
    min-height: 1.5em;
`